import isEmpty from "lodash.isempty";

export const mapServiceToServiceCard = ({
  type: service,
  extended_packages,
  extended_package_items,
  extended_services,
  status,
  scheduled_status,
  mappedStatus
}) => {
  return {
    label: [service?.label, service?.sublabel].filter(f => !isEmpty(f)).join(" - "),
    statuses: mappedStatus,
    packages: extended_packages?.map(pkg => pkg?.package?.label),
    packageItems: extended_package_items?.map(pkg => pkg?.item?.label),
    content: service?.description,
    backdrop: service?.icon_url,
    color: `#${service?.color}`,
    offset: { bottom: 0, right: 0 },
    size: 150,
  }
}
export const mapRemovePackagedServices = ({
  baseServices, adjustTransaction
}) => {
  const extendedPackageItemsWithPackages = adjustTransaction?.extended_package_items
    ?.filter(item => {
      return item?.package_id
    })
    ?.map(item => item?.item?.id)
  return baseServices?.map(service => {
    const filteredServices = service?.extended_package_items
      ?.filter(item => {
        return !!item?.is_addon_enabled && !extendedPackageItemsWithPackages?.includes(item?.id)
      })
    return {
      ...service,
      extended_package_items: filteredServices
    }
  })
}
export const mapAdjustTransactionToServiceItems = ({
  adjustTransactions,
  services
}) => {
  const extendedPackagesIds = adjustTransactions?.extended_packages?.map(pkg => pkg?.package?.id)
  let nonPackageLineItems = []
  let packageLineItems = []
  adjustTransactions?.extended_package_items?.forEach(pkg => {
    if (extendedPackagesIds.includes(pkg?.package_id)) {
      const pkgArray = packageLineItems?.[pkg?.package_id] || []
      pkgArray.push(pkg)
      packageLineItems[pkg?.package_id] = pkgArray
    } else {
      nonPackageLineItems.push(pkg)
    }
  })

  const flattenServices = services?.services?.reduce((acc, service) => {
    return acc = [...acc, ...service?.extended_package_items]
  }, [])

  return adjustTransactions?.extended_package_items?.map(item => {
    let mappedItem = flattenServices?.find(sItem => sItem?.id === item?.item?.id)
    if (!mappedItem) {
      mappedItem = item?.item
    }
    if (extendedPackagesIds.includes(item?.package_id)) {
      return {
        ...item,
        item: mappedItem,
        showInCart: false
      }
    } else {
      return {
        ...item,
        item: mappedItem,
        showInCart: true
      }
    }

  })
  return services?.services?.reduce((acc, service) => {
    const serviceItems = service?.extended_package_items?.filter(item => adjustTransactions?.extended_package_items?.includes(item?.id))
    return acc = [...acc, ...serviceItems]
  }, [])
}

export const mapServiceItemsToAdjustTransaction = ({
  serviceItems
}) => {
  return serviceItems?.map(item => {
    return {
      item: {
        id: item?.item?.id,
        label: item?.item?.label,
      },
      is_adhoc: item.is_adhoc,
      package_id: item?.package_id
    }
  })

}

export const mapServiceToTransactionList = ({
  booking,
  adjustTransaction,
  transaction,
  services
}) => {
  const extendedPackagesIds = adjustTransaction?.extended_packages?.map(pkg => pkg?.package?.id)
  let nonPackageLineItems = []
  let packageLineItems = []
  adjustTransaction?.extended_package_items?.forEach(pkg => {
    if (extendedPackagesIds.includes(pkg?.package_id)) {
      const pkgArray = packageLineItems?.[pkg?.package_id] || []
      pkgArray.push(pkg)
      packageLineItems[pkg?.package_id] = pkgArray
    } else {
      nonPackageLineItems.push(pkg)
    }
  })

  packageLineItems = Object.keys(packageLineItems).map(key => {
    const pkg = adjustTransaction?.extended_packages?.find(pkg => `${pkg?.package?.id}` === key)
    return {
      pkg,
      items: packageLineItems[key]
    }
  })

  const serviceMap = services?.services?.find(s => s?.type?.id === booking?.type?.id)
  packageLineItems = packageLineItems.map(pkg => {
    const items = pkg?.items?.filter(item => {
      const service = serviceMap?.extended_package_items?.find(sPkg => item?.item?.id === sPkg?.id)
      return !!service
    }).map(item => {
      const service = serviceMap?.extended_package_items?.find(sPkg => item?.item?.id === sPkg?.id)
      return {
        fee: service?.fee,
        label: service?.label,
        isWhitelabelCovered: service?.is_white_label_covered,
        isInPackage: !!item?.package_id,
        id: service?.id,
        disabled: item?.disabled
      }
    })
    const actualPackage = serviceMap?.extended_packages?.find(sPkg => sPkg?.id === pkg?.pkg?.package?.id)
    return {
      package: {
        id: pkg?.pkg?.package?.id,
        label: pkg?.pkg?.package?.label,
        name: pkg?.pkg?.package?.name,
        // fee: items?.reduce((acc, item) => acc + item?.fee, 0),
        fee: actualPackage?.fee ?? items?.reduce((acc, item) => acc + item?.fee, 0),
      },
      items
    }
  })
  nonPackageLineItems = nonPackageLineItems.map(item => {
    const service = serviceMap?.extended_package_items?.find(sPkg => item?.item?.id === sPkg?.id)
    return {
      fee: service?.fee,
      label: service?.label,
      isWhitelabelCovered: service?.is_white_label_covered,
      id: service?.id,
      disabled: item?.disabled
    }
  })

  const map = [
    ...packageLineItems,
    {
      package: {
        id: null,
        label: "Extended Tests",
        name: "Extended Tests",
      },
      items: nonPackageLineItems
    }

  ]
  return map
}


const ServiceCardTypes = [
  {
    key: [
      "service.blood_test_specimen.COVID_19_POC_ANTIBODY",
      "service.antibody_poc_test",
    ],
    label: "COVID Antibody",
    subHeader: "Point-of-Care",
    content: "Fastest way to detect COVID-19 previous infection",
    color: "#E4B3AC",
    backdrop: "assets/images/backdrop/01-covidpoc.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["service.blood_test_specimen.COVID_19_IGG_QUANT_ANTIBODY"],
    label: "COVID Antibody",
    subHeader: "Lab Test",
    content: "Best way to detect COVID-19 previous infection",
    color: "#A2D2D0",
    backdrop: "assets/images/backdrop/02-covidantibody.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: [
      "service.blood_test_specimen.COVID_19_POC_ANTIGEN_NASAL",
      "service.antigen_nasal_poc_test",
    ],
    label: "COVID Antigen",
    subHeader: "Rapid Test",
    content: "Detects  early stage of COVID-19 infection",
    color: "#7F8AAC",
    backdrop: "assets/images/backdrop/03-antigen.png",
    offset: { bottom: 0, right: 77 / 4 },
    size: 150,
  },
  {
    key: [
      "service.blood_test_specimen.COVID_19_RT_PCR",
      "service.blood_test_specimen.COVID_19_RT_PCR_SMC",
      "service.pcr_lab_test",
      "service.pcr_lab_test_sgd",
    ],
    label: "COVID RT PCR",
    subHeader: "Swab Test",
    content: "Most accurate test to detect COVID-19 infection",
    color: "#83B9D2",
    backdrop: "assets/images/backdrop/04-rtpcr.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["service.blood_test_specimen"],
    label: "Laboratory Test",
    subHeader: "Mobile Service",
    content: "Hospital grade lab tests done by a registered nurse",
    color: "#7F8AAC",
    backdrop: "assets/images/backdrop/05-labtest.png",
    offset: { bottom: 0, right: 162 / 4 },
    size: 150,
  },
  {
    key: ["service.iv_therapy.GLUTATHIONE"],
    label: "Glutathione",
    subHeader: "IV Treatment",
    content: "Safe intravenous treatment done by a registered nurse",
    color: "#74BACD",
    backdrop: "assets/images/backdrop/06-gluta.png",
    offset: { bottom: 0, right: 61 / 4 },
    size: 150,
  },
  {
    key: ["service.vaccination.INFLUENZA"],
    label: "Influenza",
    subHeader: "Quadrivalent",
    content: "Flu vaccination done by a registered nurse",
    color: "#BDC4D9",
    backdrop: "assets/images/backdrop/07-flu.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["service.vaccination.HPV"],
    label: "HPV",
    subHeader: "Gardasil",
    content: "Vaccination against HPV done by a registered nurse",
    color: "#A2D2D0",
    backdrop: "assets/images/backdrop/08-hpv.png",
    offset: { bottom: 0, right: 91 / 4 },
    size: 150,
  },
  {
    key: ["service.vaccination.PNEUMONIA"],
    label: "Pneumonia",
    subHeader: "Pneumovax 23",
    content: "Vaccination done by a registered nurse",
    color: "#94BAD6",
    backdrop: "assets/images/backdrop/09-pneumonia.png",
    offset: { bottom: 0, right: 34 / 4 },
    size: 150,
  },
  {
    key: ["massage.office_syndrome_therapy"],
    label: "Office Syndrome",
    subHeader: "Therapy",
    content: "Deep tissue - Neuromuscular session to treat postural stress",
    color: "#7F8AAC",
    backdrop: "assets/images/backdrop/10-office_syndrome.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["massage.shiatsu"],
    label: "Shiatsu Massage",
    subHeader: "Therapy",
    content: "Traditional massage with acupressure and stretching",
    color: "#EDB4AD",
    backdrop: "assets/images/backdrop/11-shiatsu.png",
    offset: { bottom: 0, right: 0 },
    size: 130,
  },
  {
    key: ["massage.swedish"],
    label: "Swedish Massage",
    subHeader: "Aromatherapy",
    content: "Massage with essential oil aromatherapy",
    color: "#78BDBA",
    backdrop: "assets/images/backdrop/12-swedish_aroma.png",
    offset: { bottom: 0, right: 0 },
    size: 130,
  },
  {
    key: ["massage.swed_thera"],
    label: "Swedish Massage",
    subHeader: "Therapeutic",
    content: "Deep massage using Swedish movements ",
    color: "#74BACD",
    backdrop: "assets/images/backdrop/13-swedish_thera.png",
    offset: { bottom: 0, right: 0 },
    size: 130,
  },
  {
    key: ["hfc"],
    label: "Hand & Foot Care",
    subHeader: "Total Package",
    content: "Full nail care package accompanied by a massage",
    color: "#B1BAD4",
    backdrop: "assets/images/backdrop/14-hfc.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["massage.hand_and_foot_care"],
    label: "Thai Foot Massage",
    subHeader: "Therapy",
    content: "Massage focusing on the lower legs and feet ",
    color: "#EFCAB2",
    backdrop: "assets/images/backdrop/15-tfm.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
  {
    key: ["massage.foot scrub"],
    label: "Foot Scrub",
    subHeader: "Exfoliation",
    content: "Spa foot scrub experience to exfoliate the feet",
    color: "#78BDBA",
    backdrop: "assets/images/backdrop/16-footscrub.png",
    offset: { bottom: 0, right: 0 },
    size: 150,
  },
];

export default ServiceCardTypes;
